var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasDarkKitchen && !_vm.isAlmacenero)?_c('sidebar-item',{attrs:{"link":{
    name: 'On Demand',
    icon: 'ni ni-shop text-primary'
  }}},[_c('sidebar-item',{attrs:{"link":{
      name: 'Estado de pedidos',
      path: '/foodcourt/pedidos/estados',
      icon: 'ni ni-cart text-primary'
    }}}),_c('sidebar-item',{attrs:{"link":{
      name: 'Pedidos',
      path: '/foodcourt/pedidos',
      icon: 'ni ni-cart text-primary'
    }}}),_c('sidebar-item',{attrs:{"link":{
      name: 'Tiempos de preparación',
      path: '/foodcourt/tiempos-preparacion',
      icon: 'ni ni-watch-time text-primary'
    }}}),_c('sidebar-item',{attrs:{"link":{
      name: 'Tiempo no disponible',
      path: '/foodcourt/tiempo-no-disponible',
      icon: 'ni ni-button-power text-primary'
    }}}),_c('sidebar-item',{attrs:{"link":{
      name: 'Disponibilidad de carta',
      path: '/foodcourt/carta-disponibilidad',
      icon: 'ni ni-collection text-primary'
    }}}),_c('sidebar-item',{attrs:{"link":{
      name: 'Historial de carta',
      path: '/foodcourt/carta-historial',
      icon: 'ni ni-single-copy-04 text-primary'
    }}}),_c('sidebar-item',{attrs:{"link":{
      name: 'Cargos',
      path: '/foodcourt/cargos',
      icon: 'ni ni-cart text-primary'
    }}}),_c('sidebar-item',{attrs:{"link":{
      name: 'Niveles',
      path: '/foodcourt/niveles',
      icon: 'ni ni-diamond text-primary'
    }}}),_c('sidebar-item',{attrs:{"link":{
      name: 'Carta',
      path: '/foodcourt/restaurant',
      icon: 'ni ni-tag text-primary'
    }}}),_c('sidebar-item',{attrs:{"link":{
      name: 'Horario',
      path: '/foodcourt/restaurantes',
      icon: 'ni ni-cart text-primary'
    }}}),_c('sidebar-item',{attrs:{"link":{
      name: 'Feedback',
      path: '/foodcourt/feedback',
      icon: 'ni ni-single-02 text-primary'
    }}}),_c('sidebar-item',{attrs:{"link":{
      name: 'Plataformas',
      path: '/foodcourt/platforms',
      icon: 'ni ni-single-03 text-primary'
    }}}),_c('sidebar-item',{attrs:{"link":{
      name: 'Reclamos',
      path: '/foodcourt/claims',
      icon: 'ni ni-book-bookmark text-primary'
    }}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }